import type React from 'react'

/**
 * The App component is used to render content which should be present on _all_ routes within this app
 */
export function App(props: {children?: React.ReactNode}) {
  return <>{props.children}</>
}

try{ App.displayName ||= 'App' } catch {}